<h2>Business Functionality</h2>
<div class="container">
  <app-card-shortcuts *ngFor="let card of this.cards" [hotLink]="card"></app-card-shortcuts>
</div>

